import api from '../../api/openstack'

export default {
  namespaced: true,

  state: {
    billingList: [],
    interimBillingItemList: [],
    interimBillingSummary: [],
    prices: []
  },

  getters: {
    getBillingList: (state) => {
      return state.billingList
    },
    getInterimBillingItemList: (state) => {
      return state.interimBillingItemList
    },
    getInterimBillingSummary: (state) => {
      return state.interimBillingSummary
    },
    getPrices: (state) => {
      return state.prices
    }
  },
  actions: {
    async getBillingList ({ commit }) {
      commit('setLoadingState', true, {root: true})
      await api.billing.getBillingList().then((billing) => {
        commit('setBillingList', billing)
      })
      commit('setLoadingState', false, {root: true})
    },
    async getInterimBilling ({ commit }) {
      commit('setLoadingState', true, {root: true})
      await api.billing.getInterimBilling().then((interimBilling) => {
        commit('setInterimBillingItemList', interimBilling.items)
        commit('setInterimBillingSummary', interimBilling.summary)
      })
      commit('setLoadingState', false, {root: true})
    },
    async getPrices ({ commit }) {
      commit('setLoadingState', true, {root: true})
      await api.billing.getPrices().then((prices) => {
        commit('setPrices', prices)
      })
      commit('setLoadingState', false, {root: true})
    },
    getPdfBilling ({ commit }, data) {
      api.billing.getPdfBilling({ commit }, data).then((pdfData) => {
        const pdf = new Blob([pdfData], {
          type: 'application/pdf'
        })
        const url = window.URL.createObjectURL(pdf)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'invoice.pdf')
        document.body.appendChild(link)
        link.click()
      })
    }
  },
  mutations: {
    setBillingList (state, billing) {
      state.billingList = billing
    },
    setInterimBillingItemList (state, interimBillingItemList) {
      state.interimBillingItemList = interimBillingItemList
    },
    setInterimBillingSummary (state, interimBillingSummary) {
      state.interimBillingSummary = interimBillingSummary
    },
    setPrices (state, prices) {
      state.prices = prices
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/billing.js